import {
  isNil,
  curry,
  is,
  find,
  descend,
  when,
  compose,
  toLower,
  sortWith,
  ascend,
  cond,
  equals,
  always,
  T,
  reverse,
  length,
  prop,
  values,
  sortBy,
  groupBy,
  propOr,
  map,
  flatten,
  defaultTo,
} from "ramda"
import { SortDirection } from "react-virtualized"
import { propToLower } from "js/includes/common/utils"

export const sortByFieldNameCaseInsensitive = curry((propName, sortDirection, data) =>
  sortWith([
    cond([
      [always(equals("ASC", sortDirection)), ascend(propToLower(propName))],
      [always(equals("DESC", sortDirection)), descend(propToLower(propName))],
      [
        T,
        () => {
          throw new Error(`Invalid sortDirection: ${sortDirection}`)
        },
      ],
    ])(),
  ])(data),
)

const cellDataGetter = (rowData, sortBy, columns) => {
  if (!isNil(rowData[sortBy])) return rowData[sortBy]

  const col = find(({ dataKey }) => dataKey === sortBy, columns) || {}
  const { cellDataGetter } = col
  return cellDataGetter ? cellDataGetter({ rowData }) : null
}

export const sortTableList = (list = [], sortBy, sortDirection, columns = []) => {
  const normalize = compose(defaultTo(""), when(is(String), toLower), rowData =>
    cellDataGetter(rowData, sortBy, columns),
  )

  return sortWith([
    cond([
      [() => sortDirection === "ASC", ascend(normalize)],
      [() => sortDirection === "DESC", descend(normalize)],
    ]),
  ])(list)
}

//Overrides the default sort function to sort by the priority field first
export const sortTableListWithPriority = (list, sortBy, sortDirection, columns) =>
  compose(
    flatten,
    map(prioritizedList => sortTableList(prioritizedList, sortBy, sortDirection, columns)),
    when(() => sortDirection === "ASC", reverse),
    values,
    groupBy(propOr(0, "priority")),
  )(list)

export const sortMultiTypeTableList = (list, sortByProp, sortDirection) =>
  compose(
    when(
      _ =>
        // special use case where we calculate a time since _
        // 'since' is a backwards reference, so it is naturally reversed
        // this reverse normalizes it
        ["updateTime", "modified"].includes(sortByProp),
      reverse,
    ),
    when(_ => equals(sortDirection, SortDirection.ASC), reverse),
    sortBy(compose(when(is(Array), length), when(is(String), toLower), when(isNil, always(0)), prop(sortByProp))),
    when(is(Object), values),
  )(list)
